import react from 'react'; // eslint-disable-line
import { graphql, useStaticQuery } from 'gatsby';
import { StrapiPage } from '../gatsby/types/strapi-page';

export type AllPages = {
  allStrapiPage: {
    edges: {
      node: StrapiPage;
    }[]
  }
}

export const useStrapiPages = (
): StrapiPage[] => {
  const { allStrapiPage } = useStaticQuery<AllPages>(graphql`
    query {
      allStrapiPage(filter: {
        pageSettings: {publishStatus: {eq: true}},
        seoSettings: {metaIndex: {eq: "index"}},
      }) {
        edges {
          node {
            id
            title
            pageSettings {
              id
              slug
              subpath
              language
              publishStatus
              parentPagePath
              parentPageTitle
            }
            additionalPageSettings {
              sitemapGroup
            }
          }
        }
      }
    }
  `);

  return allStrapiPage.edges.map(({ node }) => node);
};

export default useStrapiPages;
